const formsList = [
  /*{
    type: "form",
    category: "SB",
    formNumber: "create-deal-sheet",
    title: "Creating your Deal Sheet",
  },*/
  {
    type: "form",
    category: "S",
    formNumber: "ESRA",
    title: "Exclusive Seller Representation Agreement (ESRA)",
  },
  {
    type: "form",
    category: "S",
    formNumber: "ESRA-condo-sch",
    title: "ESRA - Condo Property Schedule",
  },
  {
    type: "form",
    category: "S",
    formNumber: "ESRA-country-sch",
    title: "ESRA - Country Property Schedule",
  },
  {
    type: "form",
    category: "S",
    formNumber: "ESRA-defect-disclosure",
    title: "ESRA - Defect Disclosure Schedule",
  },
  {
    type: "form",
    category: "S",
    formNumber: "ESRA-amendment",
    title: "ESRA - Amendment",
  },
  {
    type: "form",
    category: "S",
    formNumber: "ESRA-termination",
    title: "ESRA - Termination",
  },

  {
    type: "form",
    category: "B",
    formNumber: "EBRA",
    title: "Exclusive Buyer Representation Agreement (EBRA)",
  },
  {
    type: "form",
    category: "B",
    formNumber: "EBRA-amendment",
    title: "EBRA - Amendment",
  },
  {
    type: "form",
    category: "B",
    formNumber: "EBRA-termination",
    title: "EBRA - Termination",
  },
  {
    type: "form",
    category: "B",
    formNumber: "ResidentialPurchaseContract",
    title: "Residential Purchase Contract",
  },
  {
    type: "form",
    category: "B",
    formNumber: "RPS-condo",
    title: "Residential Condo Purchase Contract",
  },
  {
    type: "form",
    category: "B",
    formNumber: "RPS-country",
    title: "Country Residential Purchase Contract",
  },
  {
    type: "form",
    category: "B",
    formNumber: "country-schedule",
    title: "Country Residential Property Schedule",
  },
  {
    type: "form",
    category: "B",
    formNumber: "manufactured-schedule",
    title: "Manufactured Home Schedule",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "addendum",
    title: "Addendum",
  },
  {
    type: "form",
    category: "B",
    formNumber: "amendment-purchase-contract",
    title: "Amendment - Purchase Contract",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "notice-satisfy-conditions",
    title: "Notice: Waiver/Satisfaction of Conditions",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "notice-non-satisfy-conditions",
    title: "Notice: Non-Waiver/Non-Satisfaction of Conditions",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "agreement-to-rep-both",
    title: "Agreement to Represent Both Buyer and Seller",
  },
  {
    type: "form",
    category: "S",
    formNumber: "seller-cust-fee-agreement",
    title: "Seller Customer Acknowledgement and Fee Agreement",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "cust-acknowledgement",
    title: "Customer Acknowledgement",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "realtor-disclosure-to-rep-party",
    title: "REALTOR® Disclosure to Represented Person",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "realtor-disclosure-to-unrep-party",
    title: "REALTOR® Disclosure to an Unrepresented Person",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "fee-disclosure",
    title: "Fee Disclosure",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "referral-fee-consent",
    title: "Referral Fee Consent",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "realtor-cooperation-policy",
    title: "REALTOR® Cooperation Policy Form",
  },
  {
    type: "form",
    category: "SB",
    formNumber: "agri-purchase-contract",
    title: "Agricultural Purchase Contract",
  },
];

export default formsList;
